export const ZERO_BI = BigInt(0);

export const BILLION = 1_000_000_000;
export const HUNDRED_MILLION = 100_000_000;
export const MILLION = 1_000_000;
export const HUNDRED_THOUSAND = 100_000;
export const THOUSAND = 1_000;
export const HUNDRED = 100;
